if (!window.cip_Custom) {
    window.cip_Custom = {};
}
(function () {
    "use strict";

    /**** @CC CLIENT_SPECIFIC_CUSTOMIZATION - START
     /**** - this is where functions that add new functionality which don't override default rendering engine functions go
     /****
     /**** below is an example of how you add new functionallity. noting the following:
     /**** 	-> the 'cip_Custom' object name needs to be used for all new properties and functions
     /****
     /**** 	cip_Custom.lastGetQuestionsTask = null;
     /****
     /**** 	cip_Custom.getLastQuestionInSection = function(pageId, sectionName){
	/**** 		var lastQuestionInSection = null;
	/****
	/**** 		$.each($("#" + cc_View.getSectionDivId(pageId, sectionName) + " .questionPanel:visible"), function(){
	/**** 			var questionId = $(this).attr('cc-panel');
	/****
	/**** 			if(cc_Model.anyLevelQuestionMap[questionId].type.value != "type-less"){
	/**** 				lastQuestionInSection = cc_Model.anyLevelQuestionMap[questionId];
	/**** 			}
	/**** 		});
	/****
	/**** 		return lastQuestionInSection;
	/**** 	};
    /********************************************************************************************************/
    cc_Config.showQuestionOptionalAnnotation = true;

    cip_Custom.ONLINE_HL_RULEBOOK = "OnlineHomeLoan";
    cip_Custom.UNSECURED_RULEBOOK = "Unsecured";
    cip_Custom.VISA_MIGRATION_RULEBOOK = "VisaMigration";

    cip_Custom.isUnsecured = function() {
        return (cc_Config.rulebookName == cip_Custom.UNSECURED_RULEBOOK || cc_Config.rulebookName == cip_Custom.VISA_MIGRATION_RULEBOOK);
    }

    cip_Custom.isVisaMigration = function() {
        return cc_Config.rulebookName == cip_Custom.VISA_MIGRATION_RULEBOOK;
    }

    cip_Custom.isOnlineHomeLoan = function() {
        return cc_Config.rulebookName == cip_Custom.ONLINE_HL_RULEBOOK;
    }

    cip_Custom.isComplexLending = function() {
        return (cc_Config && cc_Config.application.monitoredQuestions.find(e => e.id == 'iComplexLending')?.answer === 'true')
    }

    cip_Custom.shouldShowSpeakToExpert = function() {
        return (cc_Config && cc_Config.application.monitoredQuestions.find(e => e.id == 'iShowSpeakToExpert')?.answer !== 'false')
    }

    cc_Renderer.completeInit = function () {
        $('#cloudcase-form').show();

        if(cip_Custom.isOnlineHomeLoan()) {
            $("#cloudcase-page-navigator-restricted").append(cip_Custom.getSpeakToExpertHtml());
            cip_Custom.bootSpeakToExpert();
        }

    };

    cip_Custom.toApplicationByLeadId = function (leadId) {
        var response;
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/onlinehomeloan/interview/search/' + leadId,
            async: false,
            success: function(data) {
                response = data;
            },
            error: function() {
                response = null;
            }
        })

        return response;
    };

    cip_Custom.getSpeakToExpertHtml = function(){
        return `<div id="tsb-speak-specialist" style="margin-top: 20px;">
                    <div class="message-card" v-if="shouldShow">
                        <p style="font-size: 19px !important; font-weight: 600; line-height: 26px;">Need help?</p>
                        <p style="font-weight: 600; font-size: 16px !important; line-height: 26px; margin-bottom: 20px;">Talk to a specialist</p>
                        <a id="tsb-speak-specialist-button" @click="emitClicked" class="form-control btn btn-primary" href="#" style="margin-top: 10px;">Start</a>
                    </div>
            </div>`;
    }

    cip_Custom.getApplicationType = function() {

        if(cip_Custom.isOnlineHomeLoan()) {
            return 'home loan';
        }

        if(cip_Custom.isUnsecured()) {

            if (cc_Model.anyLevelQuestionMap.CreditCardOngoingBasis) {
                return 'credit card';
            }

            return 'personal loan';
        }

    }

    cip_Custom.bootSpeakToExpert = function() {
        if(window.Vue) {
            window.speakToAnExpert = new Vue({
                name: "Speak To An Expert Button",
                el: "#tsb-speak-specialist",
                data: {
                    shouldShow : false
                },
                methods: {
                    emitClicked: function() {

                        const url = cc_Util.getRelativePath() + 'json/applications/speak_to_expert/' + cc_Config.applicationId;

                        $.ajax({
                            url: url,
                            type: 'POST',
                            headers: {
                                "X-Atlas-Environment" : cc_Config.environment === 'p' ? "PRODUCTION" : "STAGING"
                            },
                            data: {},
                            success: function() {
                                cc_Controller.cleanAndRefresh(function(){});
                            }
                        });

                    }
                }
            })
        }
    }

    cc_View.createSection = function (pageId, section) {

        if (cip_Custom.isUnsecured() && !cip_Custom.isVisaMigration()) {
            return cc_View.createUnsecuredSection(pageId, section);
        }

        if (cip_Custom.isVisaMigration()) {
            return cc_View.createVisaMigrationSection(pageId, section);
        }

        if (cip_Custom.isOnlineHomeLoan()) {
            return cc_View.createOnlineHomeLoanSection(pageId, section);
        }


        var html = '<div id="' + cc_View.getSectionFieldsetId(pageId, section) + '" class="sectionHeader">';

        if(section){
            html +=		'<legend><div class="headerContainer"><span>' + section + '</span></div></legend>';
        }

        html +=			'<div id="' + cc_View.getSectionDivId(pageId, section) + '"></div>' +
            '</div>';

        return html;
    };

    cc_View.createQuestionContainer = function (question) {

        var styleProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);

        var html = '';

        var classes = 'questionContainer';

        if(styleProperty == "SummaryInformation"){
            classes += ' summaryInformation';
        } else if(styleProperty == "PersonalLoanSummary"){
            classes += ' personalLoanSummary';
        } else if (styleProperty == "InfoMessage") {
            classes += ' message-card';
        } else if (styleProperty == "SuccessMessage") {
            classes += ' message-card success';
        } else if (styleProperty == "SpecialMessage") {
            classes += ' message-card special';
        } else if (styleProperty == "WarningMessage") {
            classes += ' message-card warning';
        } else if (styleProperty == "ErrorMessage") {
            classes += ' message-card error';
        } else if (styleProperty == "SubHeader") {
            classes += ' subheader';
        }

        /**
         * The following are custom question types; we are completely re-writing the question code to allow a bespoke
         * UI. If at any stage there is interactivity required here, these will need to be re-written as widgets.
         */
        if(cc_Config.rulebookName === cip_Custom.ONLINE_HL_RULEBOOK) {
            if (styleProperty === "LandingPage") {
                return cip_Custom.createLandingPageHTML();
            }
        }

        if(styleProperty == "ErrorMessage") {
            html += '<div class="' + classes + ' ' + cc_View.getQuestionLayoutTextPosition(question, 'fullWidthQuestion') + '" cc-type="' + question.type.value + '">' +
                    '<div class="row layoutHorizontalRow">' +
                        '<div class="icon icon-explainer-error">' +
                            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '<path fill-rule="nonzero" clip-rule="nonzero" d="M7 12.6C10.0928 12.6 12.6 10.0928 12.6 7C12.6 3.90721 10.0928 1.4 7 1.4C3.90721 1.4 1.4 3.90721 1.4 7C1.4 10.0928 3.90721 12.6 7 12.6ZM7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z" fill="#CD1713"/>' +
                                '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.29912 10.2004C6.29912 10.587 6.61252 10.9004 6.99912 10.9004C7.38572 10.9004 7.69912 10.587 7.69912 10.2004L7.69912 6.27007C7.69912 5.88347 7.38572 5.57007 6.99912 5.57007C6.61252 5.57007 6.29912 5.88347 6.29912 6.27007L6.29912 10.2004ZM6.99922 3.20048C6.61262 3.20048 6.29922 3.51388 6.29922 3.90048C6.29922 4.28708 6.61262 4.60048 6.99922 4.60048C7.38582 4.60048 7.69922 4.28708 7.69922 3.90048C7.69922 3.51388 7.38582 3.20048 6.99922 3.20048Z" fill="#fff"/>' +
                           '</svg>' +
                        '</div>' +
                        cc_View.createQuestionHeadingHtml(question) +
                        cc_View.createQuestionResultAndErrorPanelHtml(question) +
                        cc_View.createQuestionHelpPanelHtml(question) +
                    '</div>' +
                '</div>';
        } else {
            html += '<div class="' + classes + ' ' + cc_View.getQuestionLayoutTextPosition(question, 'fullWidthQuestion') + '" cc-type="' + question.type.value + '">' +
                cc_View.createQuestionHeadingHtml(question) +
                //            cc_View.createQuestionHelpButtonHtml(question) +
                cc_View.createQuestionResultAndErrorPanelHtml(question) +
                cc_View.createQuestionHelpPanelHtml(question) +
                '</div>';
        }

        return html;
    };

    cc_View.createQuestionHtml = function (question) {
        var classes = 'questionPanel';

        classes += (cc_View.isViewableQuestion(question) == true ? ' shownQuestionPanel' : ' hiddenQuestionPanel');
        classes += (question.text ? ' shownQuestionTextPanel' : ' hiddenQuestionTextPanel');

        if(question.concealed == true){
            classes += ' concealed';
        }

        if(cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT, question) == 'Horizontal'){
            classes += ' layoutHorizontal';
        }

        if(cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question) == 'ExpenseGroup'){
            classes += ' expense-group';
        }

        if(cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question) == 'EmploymentIncome'){
            classes += ' employment-income';
        }

        if(cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question) == 'HalfTopMargin'){
            classes += ' half-top-margin';
        }

        var html = '<div id="' + cc_View.getQuestionPanelDivId(question.id) + '" cc-panel="' + question.id + '" class="' + classes + '">';

        if (question.type.hasAnInputType) {
            switch (question.type.value) {
                case 'multi-select':
                    html += cc_View.createMultiSelectQuestionHtml(question);
                    break;
                case 'single-select':
                case 'boolean':
                    html += cc_View.createSingleSelectQuestionHtml(question);
                    break;
                case 'free-text':
                    html += cc_View.createFreeTextQuestionHtml(question);
                    break;
                case 'number':
                case 'range':
                    html += cc_View.createNumberQuestionHtml(question);
                    break;
                case 'date':
                    html += cc_View.createDateQuestionHtml(question);
                    break;
                case 'search':
                    html += cc_View.createSearchQuestionHtml(question);
                    break;
                case 'add-document':
                    html += cc_View.createAddDocumentQuestionHtml(question);
                    break;
                case 'external-widget':
                    html += cc_View.createExternalWidgetQuestionHtml(question);
                    break;
            }

        }else{
            html +=	cc_View.createQuestionContainer(question);
        }

        if (question.hasSubQuestions) {
            html += cc_View.createSubQuestionsHtml(question);
        }

        html += '</div>';

        return html;
    };


    cc_View.createUnsecuredSection = function(pageId, section) {

        let widgetData;
        let product = '';
        let imgClass = '';

        if (cc_Model.anyLevelQuestionMap.CreditCardSelectorWidget) {
            widgetData = JSON.parse(cc_Model.anyLevelQuestionMap.CreditCardSelectorWidget.entered[0]);
            product = widgetData.selectedCard.name;
        }

        var breadCrumbs = `
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.841495 10.1888C0.425859 10.5525 0.383741 11.1843 0.747423 11.5999C1.11111 12.0155 1.74287 12.0577 2.1585 11.694L0.841495 10.1888ZM2.1585 0.30626C1.74287 -0.0574217 1.1111 -0.0153045 0.747423 0.400332C0.383741 0.815969 0.425858 1.44773 0.841495 1.81141L2.1585 0.30626ZM2.1585 11.694L7.19855 7.28394L5.88154 5.77879L0.841495 10.1888L2.1585 11.694ZM7.19855 4.7163L2.1585 0.30626L0.841495 1.81141L5.88154 6.22146L7.19855 4.7163ZM7.19855 7.28394C7.97529 6.60429 7.97529 5.39595 7.19855 4.7163L5.88154 6.22146C5.74763 6.10428 5.74763 5.89596 5.88154 5.77879L7.19855 7.28394Z" fill="white"/>
            </svg>
            
        `;

        if (product !== '') {
            if (product === 'Low Rate Mastercard') {
                imgClass = 'cardImageLowRate';
            } else if (product === 'Platinum Mastercard') {
                imgClass = 'cardImagePlatinum';
            }
            product = 'TSB ' + product;
            breadCrumbs += `
                <span>Apply</span>
                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.841495 10.1888C0.425859 10.5525 0.383741 11.1843 0.747423 11.5999C1.11111 12.0155 1.74287 12.0577 2.1585 11.694L0.841495 10.1888ZM2.1585 0.30626C1.74287 -0.0574217 1.1111 -0.0153045 0.747423 0.400332C0.383741 0.815969 0.425858 1.44773 0.841495 1.81141L2.1585 0.30626ZM2.1585 11.694L7.19855 7.28394L5.88154 5.77879L0.841495 10.1888L2.1585 11.694ZM7.19855 4.7163L2.1585 0.30626L0.841495 1.81141L5.88154 6.22146L7.19855 4.7163ZM7.19855 7.28394C7.97529 6.60429 7.97529 5.39595 7.19855 4.7163L5.88154 6.22146C5.74763 6.10428 5.74763 5.89596 5.88154 5.77879L7.19855 7.28394Z" fill="white"/>
                </svg>
                <span class="highlight">${product}</span>
            `;
        } else {
            breadCrumbs += `<span class="highlight">Apply</span>`;
        }

        var classes = "sectionHeader";

        if (pageId == "ExpensesPage" && section != "Your expenses" && section != "Confirmation") {
            classes += " halfSection";
        } else if (pageId == "ExpensesPage" && section == "Confirmation") {
            classes += " extra-margin-top";
        }

        let html = '<div id="' + cc_View.getSectionFieldsetId(pageId, section) + '" class="' + classes + '">';

        if(section) {
            html += `
                <legend>
                    <div class="headerContainer headerWithBreadcrumbs">
                        <div class="headerBreadcrumbs">
                            <span>Credit Cards</span>
                            ${breadCrumbs}
                        </div>

                        <span>${section}</span>
                    </div>
                    <div class="headerCardImage ${imgClass}"></div>
                </legend>
            `;
        }


        html += `<div id="${cc_View.getSectionDivId(pageId, section)}"></div>`;
        html += `</div>`

        return html;
    }

    cc_UI.createSimpleDialog = function (dialog, item) {
        var defaults = {
            backgroundColor: '#FFFFFF',
            cancelText: 'Cancel',
            closeOnEscape: true,
            closable: true,
            enforceMaximumHeight: true,
            modal: true,
            okText: 'Ok',
            positionFromTop: cc_UI.dialogDefaultPositionFromTop,
            showButtons: true,
            supportsErrors: true,
            supportsWarnings: true,
            width: cc_UI.dialogDefaultWidth,
            maxWidth: 'none'
        };

        $.extend(defaults, dialog);

        // remove this dialog if it exists
        cc_UI.hideDialog(defaults.id);

        // setup buttons
        var buttons = {};

        // cancel button
        var cancel = function () {
            $('#' + defaults.id).dialog("close");
        };

        if (typeof defaults.cancel !== "function") {
            defaults.cancel = cancel;
        }

        if (defaults.closable == true) {
            buttons[defaults.cancelText] = defaults.cancel;
        }

        // additional buttons
        if (defaults.additionalButtons) {
            for (var i = 0; i < defaults.additionalButtons.length; i++) {
                var additionalButton = defaults.additionalButtons[i];

                buttons[additionalButton.text] = function () {
                    additionalButton.action.call(this);
                };
            }
        }

        // ok button
        buttons[defaults.okText] = function () {
            if (defaults.ok) {
                defaults.ok.call(this);
            } else {
                defaults.cancel.call(this); // just cancel if there is no ok action
            }
        };

        var html = '<div id="' + defaults.id + '" title="' + defaults.title + '">';

        // setup error support
        if (defaults.supportsErrors == true) {
            html += '<table class="dialogErrorContainer" style="display:none;"></table>';
        }

        // setup warning support
        if (defaults.supportsWarnings == true) {
            html += '<table class="dialogWarningContainer" style="display:none;"></table>';
        }

        html += defaults.content + '</div>';

        var position = (typeof defaults.positionFromTop !== 'undefined' ?
            { my: "top", at: "top+" + defaults.positionFromTop } :
            { my: "top", at: "top+150" });

        $('body').append(html);
        var options = {
            autoOpen: false,
            buttons: buttons,
            closeOnEscape: defaults.closeOnEscape,
            draggable: false,
            modal: defaults.modal,
            position: position,
            resizable: false,
            width: defaults.width,
            close: function (event, ui) {
                if (defaults.close) {
                    defaults.close.call(this);
                }

                if (defaults.enforceMaximumHeight === true) {
                    $('#' + defaults.id).parent().unbind('resize');
                }

                if ($('#' + defaults.id).data("ui-dialog")) {
                    $('#' + defaults.id).dialog("destroy").remove();
                }
                if ($("html").attr("dialog-depth") && parseInt($("html").attr("dialog-depth")) > 1) {
                    $("html").attr("dialog-depth", parseInt($("html").attr("dialog-depth")) - 1);
                } else {
                    $("html").css("overflow", "");
                    $("html").removeAttr("dialog-depth");
                }
            },
            open: function () {
                var jDialog = $('#' + defaults.id);
                var parent = jDialog.parent();

                cc_UI.applyDialogStyling(defaults.id, defaults.cancelText);

                parent.find('.ui-dialog-titlebar-close').hide();

                if (defaults.showButtons == false) {
                    parent.find('.ui-dialog-buttonpane').hide();
                } else {
                    parent.find('.ui-dialog-buttonpane :button').blur();
                }
                if (defaults.parentPosition) {
                    parent.css('position', defaults.parentPosition);
                }

                if (defaults.open) {
                    defaults.open.call(this);
                }

                if (defaults.showButtons == true) {
                    // override default behaviour and dont auto focus on first button
                    parent.find('.ui-dialog-buttonpane :button').blur();
                }

                if (defaults.minHeight) {
                    jDialog.css('min-height', defaults.minHeight);
                }

                if (defaults.maxHeight) {
                    jDialog.css('max-height', defaults.maxHeight);
                }

                // ensure up/down arrows work correctly for dialogs with scrollable bodies
                jDialog.attr("tabindex", "-1").css("outline", "none").focus();

                // For nesting dialogs, we need to keep track of how many are stacked so that we can remove the overflow blocking at the right time
                if ($("html").attr("dialog-depth")) {
                    $("html").attr("dialog-depth", parseInt($("html").attr("dialog-depth")) + 1);
                } else {
                    $("html").attr("dialog-depth", 1);
                    $("html").css("overflow", "hidden");
                }
            }
        };

        $.extend(options, defaults.customAttributes);

        if (defaults.beforeClose) {
            options.beforeClose = defaults.beforeClose;
        }
        $('#' + defaults.id).dialog(options);
        $('#' + defaults.id).parent().css('maxWidth', defaults.maxWidth);

        if (defaults.init) {
            defaults.init.call();
        }

        $('#' + defaults.id).dialog('open').hide();

        if (defaults.enforceMaximumHeight === true) {
            cc_UI.enforceMaximumDialogHeight(defaults.id, defaults.contentId, defaults.positionFromTop);
        };

        $('#' + defaults.id).show();

        if (defaults.firstOpen) {
            defaults.firstOpen.call(item);
        }

        return $('#' + defaults.id);
    };

    cc_UI.applyDialogStyling = function (dialogId, cancelText) {
        var jDialog = $('#' + dialogId);
        var parent = jDialog.parent();

        parent.css('border', '2px solid var(--color_active-field-outline)');

        parent.find('.ui-dialog-buttonpane :button').addClass('btn');
        parent.find('.ui-dialog-buttonpane :button:contains(' + cancelText + ')').addClass('btn-default');
        parent.find('.ui-dialog-buttonpane :button:not(:contains(' + cancelText + '))').addClass('btn-primary');
    };

    cc_View.createVisaMigrationSection = function(pageId, section) {

        var html = '<div id="' + cc_View.getSectionFieldsetId(pageId, section) + '" class="sectionHeader visaMigration">';

        if (section) {
            html +=	'<legend><div class="headerContainer"><span>' + section + '</span></div></legend>';
        }

        html +=	'<div id="' + cc_View.getSectionDivId(pageId, section) + '"></div></div>';

        return html;
    }

    cc_View.createOnlineHomeLoanSection = function(pageId, section) {

        let html = `<div id="${cc_View.getSectionFieldsetId(pageId, section)}" class="sectionHeader">`;

        if(section) {
            // Per RLTEC-386, we want to show "Your income" when it's in the borrower 1 income details.
            // This condition checks and renders the right text.
            let renderCustomHeaderForIncome = (pageId === 'IncomePage' && section === 'Borrower 1 Income Details');
            let topPageHeader = [
                {pageId: "ContactInformationPage", pannel: "Contact information"},
                {pageId: "BorrowingPurposePage", pannel: "About your loan"},
                {pageId: "Individual1PersonalDetailsPage", pannel: "Personal Details"},
                {pageId: "Individual2PersonalDetailsPage", pannel: "Personal Details"},
                {pageId: "IncomePage", pannel: "Borrower 1 Income Details"},
                {pageId: "ExpensesPage", pannel: "Your expenses"},
                {pageId: "LiabilityPage", pannel: "Liabilities"},
                {pageId: "AssetsPage", pannel: "Assets"},
                {pageId: "ConfirmationPage", pannel: "Confirmation"}
            ];

            let isTopPageHeader = topPageHeader.some(function (item) {
                return item.pageId === pageId && item.pannel === section;
            });

            if (pageId === "GettingStartedPage" || isTopPageHeader) {
                let houseGraphic = "";

                if(pageId === "GettingStartedPage") {
                    houseGraphic = `
                    <div class="houseGraphic">
                        <svg width="108" height="27" viewBox="0 0 108 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M51.7402 7.84704H46.825V4.33105H61.9704V7.84704H57.0552V22.1156H51.7402V7.84704Z" fill="#1A1C45"/>
                            <path d="M64.6411 17.7328C66.013 18.395 67.9275 18.9053 70.1278 18.9053C71.8136 18.9053 73.4143 18.599 73.4143 17.1721C73.4143 13.8601 63.9836 15.9492 63.9836 9.4772C63.9836 5.19735 68.6701 4.0249 72.6709 4.0249C74.5862 4.0249 76.4719 4.27999 77.8149 4.68788L77.822 8.35663C76.4501 7.79598 74.5574 7.54086 73.0426 7.54086C71.6996 7.54086 69.4712 7.64322 69.4712 9.19723C69.4712 12.0765 78.9011 10.1402 78.9011 16.5603C78.9011 21.1727 74.5574 22.4212 70.1279 22.4212C68.2703 22.4212 66.2816 22.1661 64.5092 21.6567L64.6411 17.7328Z" fill="#1A1C45"/>
                            <path d="M81.6141 4.33105H90.787C94.5021 4.33105 97.274 5.78349 97.274 8.84114C97.274 11.083 95.988 12.3315 93.7596 12.9938V13.045C96.4167 13.5289 97.7886 14.803 97.7886 16.9681C97.7886 21.2238 93.5878 22.1156 90.0156 22.1156H81.6141V4.33105ZM86.929 11.363H88.4157C90.1585 11.363 91.959 10.9807 91.959 9.47784C91.959 7.84704 90.2444 7.69427 88.4727 7.69427H86.929V11.363ZM86.929 18.7524H88.5008C90.4443 18.7524 92.4736 18.4973 92.4736 16.6881C92.4736 14.7518 90.3873 14.5734 88.5578 14.5734H86.929V18.7524Z" fill="#1A1C45"/>
                            <path d="M23.4126 12.6063V0C18.2303 7.25708 9.76168 12.2877 0 13.2233C9.76168 14.1582 18.2303 19.1887 23.4126 26.4465V13.8395C17.5393 13.8416 11.8019 13.5712 6.21369 13.2233C11.8019 12.8746 17.5393 12.6034 23.4126 12.6063Z" fill="#0B794B"/>
                            <path d="M23.4124 12.6063V0C28.5954 7.25708 37.0632 12.2877 46.8249 13.2233C37.0632 14.1582 28.5954 19.1887 23.4124 26.4465V13.8395C29.2856 13.8416 35.023 13.5712 40.6112 13.2233C35.023 12.8746 29.2856 12.6034 23.4124 12.6063Z" fill="#29B58B"/>
                        </svg>
                    </div>`;
                }

                html += `
                <legend class="topPageHeader ${pageId !== 'GettingStartedPage' && isTopPageHeader ? 'noImage' : ''}">
                    ${houseGraphic}
                    <div class="headerContainer headerWithBreadcrumbs">
                        <div class="headerBreadcrumbs">
                            <span>Home Loan</span>
                            <svg class="chevron-right" width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.841495 10.1888C0.425859 10.5525 0.383741 11.1843 0.747423 11.5999C1.11111 12.0155 1.74287 12.0577 2.1585 11.694L0.841495 10.1888ZM2.1585 0.30626C1.74287 -0.0574217 1.1111 -0.0153045 0.747423 0.400332C0.383741 0.815969 0.425858 1.44773 0.841495 1.81141L2.1585 0.30626ZM2.1585 11.694L7.19855 7.28394L5.88154 5.77879L0.841495 10.1888L2.1585 11.694ZM7.19855 4.7163L2.1585 0.30626L0.841495 1.81141L5.88154 6.22146L7.19855 4.7163ZM7.19855 7.28394C7.97529 6.60429 7.97529 5.39595 7.19855 4.7163L5.88154 6.22146C5.74763 6.10428 5.74763 5.89596 5.88154 5.77879L7.19855 7.28394Z" />
                            </svg>
                            <span class="highlight">Apply</span>
                        </div>
                    </div>
                    <div>
                         <span>${renderCustomHeaderForIncome ? 'Your income' : section}</span>
                    </div>
                </legend>
            `;
            } else {
                html += `
                <legend class="pannelHeader">
                    <div>
                        <span>${renderCustomHeaderForIncome ? 'Your income' : section}</span>
                    </div>
                </legend>
            `;
            }
        }

        html += `<div id="${cc_View.getSectionDivId(pageId, section)}"></div>`;
        html += `</div>`

        return html;
    }

    // creates landingPage content 'to apply for a home loan you'll need to make sure you' and 'what's the process'
    cip_Custom.createLandingPageHTML = function() {
        return `
            <div class="questionContainer fullWidthQuestion" cc-type="type-less">
                <div class="message-card" style="margin-bottom: 30px;">

                    <h2 class="calloutHeader">To apply for a home loan you'll need to make sure you:</h2>


                    <div class="iconDetailsGrid">

                        <div>
                            <svg width="20" height="20" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="15.5" cy="15" r="14" stroke="#1A124D" stroke-width="2"/>
                                <path d="M12.4531 21H10.0391V14.3906C10.0391 14.2083 10.0417 13.9844 10.0469 13.7188C10.0521 13.4479 10.0599 13.1719 10.0703 12.8906C10.0807 12.6042 10.0911 12.3464 10.1016 12.1172C10.0443 12.1849 9.92708 12.3021 9.75 12.4688C9.57812 12.6302 9.41667 12.776 9.26562 12.9062L7.95312 13.9609L6.78906 12.5078L10.4688 9.57812H12.4531V21ZM19.5781 9.42969C20.2344 9.42969 20.8385 9.53125 21.3906 9.73438C21.9479 9.9375 22.3932 10.2448 22.7266 10.6562C23.0599 11.0625 23.2266 11.5729 23.2266 12.1875C23.2266 12.6458 23.1354 13.0469 22.9531 13.3906C22.776 13.7344 22.5339 14.0365 22.2266 14.2969C21.9193 14.5521 21.5703 14.776 21.1797 14.9688C21.5859 15.1823 21.9714 15.4323 22.3359 15.7188C22.7005 16 22.9974 16.3307 23.2266 16.7109C23.4609 17.0911 23.5781 17.5339 23.5781 18.0391C23.5781 18.6745 23.4089 19.2266 23.0703 19.6953C22.7318 20.1589 22.263 20.5182 21.6641 20.7734C21.0651 21.0286 20.3698 21.1562 19.5781 21.1562C18.724 21.1562 17.9974 21.0339 17.3984 20.7891C16.7995 20.5443 16.3438 20.1953 16.0312 19.7422C15.7188 19.2839 15.5625 18.737 15.5625 18.1016C15.5625 17.5807 15.6589 17.1276 15.8516 16.7422C16.0495 16.3568 16.3151 16.026 16.6484 15.75C16.9818 15.4688 17.349 15.2292 17.75 15.0312C17.4115 14.8177 17.1016 14.5755 16.8203 14.3047C16.5443 14.0339 16.3229 13.724 16.1562 13.375C15.9948 13.026 15.9141 12.625 15.9141 12.1719C15.9141 11.5677 16.0833 11.0625 16.4219 10.6562C16.7656 10.25 17.2161 9.94531 17.7734 9.74219C18.3307 9.53385 18.9323 9.42969 19.5781 9.42969ZM17.7969 17.9609C17.7969 18.3724 17.9427 18.7135 18.2344 18.9844C18.5312 19.25 18.9688 19.3828 19.5469 19.3828C20.1458 19.3828 20.5938 19.2552 20.8906 19C21.1875 18.7396 21.3359 18.3984 21.3359 17.9766C21.3359 17.6849 21.25 17.4297 21.0781 17.2109C20.9115 16.9922 20.7005 16.7969 20.4453 16.625C20.1901 16.4479 19.9323 16.2839 19.6719 16.1328L19.4609 16.0234C19.1276 16.1745 18.8359 16.3438 18.5859 16.5312C18.3411 16.7188 18.1484 16.9297 18.0078 17.1641C17.8672 17.3984 17.7969 17.6641 17.7969 17.9609ZM19.5625 11.1953C19.1667 11.1953 18.8385 11.2969 18.5781 11.5C18.3177 11.7031 18.1875 11.9896 18.1875 12.3594C18.1875 12.6198 18.25 12.849 18.375 13.0469C18.5052 13.2396 18.6745 13.4089 18.8828 13.5547C19.0964 13.7005 19.3281 13.8359 19.5781 13.9609C19.8177 13.8464 20.0417 13.7188 20.25 13.5781C20.4583 13.4375 20.6276 13.2682 20.7578 13.0703C20.888 12.8724 20.9531 12.6354 20.9531 12.3594C20.9531 11.9896 20.8203 11.7031 20.5547 11.5C20.2943 11.2969 19.9635 11.1953 19.5625 11.1953Z" fill="#1A124D"/>
                            </svg>
                        </div>

                        <div>
                            <span>Are 18 years of age or over</span>
                        </div>
                         
                         <div>
                            <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6164 15.5508C15.5493 15.5508 15.4835 15.5735 15.432 15.6167L14.343 16.5367C14.282 16.587 14.246 16.6612 14.2436 16.7403L14.2137 17.6878L13.0289 18.9049C12.987 18.9469 12.9607 19.002 12.9523 19.0607L12.7295 20.6527L10.6427 22.283L8.90933 23.5408C8.89136 23.5528 8.87459 23.5684 8.86141 23.5852L7.87674 24.7388C7.87075 24.7447 7.46106 25.1796 7.04421 25.6396C6.83457 25.8696 6.62494 26.1056 6.46443 26.296C6.38297 26.3907 6.31588 26.4733 6.26438 26.544C6.23802 26.5787 6.21646 26.6099 6.19609 26.6434C6.17453 26.6782 6.1374 26.6806 6.1374 26.8303C6.1374 26.8015 6.135 26.8531 6.12901 26.9046C6.12182 26.9561 6.11104 27.0256 6.09787 27.1058C6.07271 27.2663 6.03917 27.47 6.00563 27.67C5.93735 28.0689 5.87026 28.4511 5.87026 28.4511C5.84391 28.5996 5.93974 28.741 6.08708 28.7721L8.57037 29.2824L10.8164 29.7928C10.9171 29.8155 11.0213 29.7808 11.0896 29.7029L12.9284 27.5575C12.9511 27.5287 12.9691 27.4976 12.9811 27.4616L13.5608 25.6911C13.5656 25.6744 13.5692 25.6588 13.5716 25.6408L13.7549 24.262L16.4083 23.0653C16.4777 23.0342 16.5305 22.9755 16.5556 22.9024C16.5808 22.8305 16.5748 22.7515 16.54 22.6844L16.1723 21.9752L16.5197 21.4397L17.8757 19.6776C17.8997 19.6477 17.9164 19.6129 17.926 19.5758L18.198 18.4857C18.2051 18.4581 18.2075 18.4294 18.2051 18.4006L18.1033 16.8338C18.0973 16.7439 18.0494 16.6637 17.9739 16.6157C17.8973 16.5678 17.8038 16.5606 17.7212 16.5942L16.5317 17.0745L15.862 15.7077C15.8153 15.6131 15.7207 15.5532 15.6165 15.5508L15.6164 15.5508Z" fill="#1A124D"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2224 2.20041C15.1193 2.2064 15.0271 2.26869 14.984 2.36332C14.9408 2.45796 14.954 2.56817 15.0187 2.64962L15.8189 3.67505L15.88 4.37584C15.8848 4.43214 15.9064 4.48485 15.9423 4.52917L16.8827 5.6708L17.9764 7.46166L18.4974 9.34835L18.3333 10.9583L18.1572 12.1335L17.5511 12.2916C17.4852 12.3084 17.4277 12.3491 17.3906 12.4066L16.9809 13.0187C16.9222 13.1062 16.9186 13.22 16.9713 13.3122L17.3798 14.0262C17.4109 14.0825 17.4612 14.1244 17.5199 14.1472L18.4615 14.5173L19.1155 14.8443L19.451 15.5415L18.8472 16.537C18.8388 16.5525 18.8304 16.5693 18.8245 16.5873L18.5178 17.4378C18.489 17.5181 18.4986 17.6067 18.5429 17.6786C18.5873 17.7504 18.6615 17.7984 18.7466 17.8091L19.3755 17.8846L19.4222 18.3434C19.433 18.4536 19.5085 18.5471 19.6139 18.5818C19.7193 18.6153 19.8343 18.583 19.9074 18.5003L20.3901 17.9541L21.2718 17.4318C21.3113 17.4079 21.3449 17.3743 21.3676 17.3348L22.4242 15.5643C22.4314 15.5523 22.4373 15.5415 22.4421 15.5296L22.9872 14.2358C23.0063 14.1891 23.0123 14.1388 23.0063 14.0885L22.8961 13.299L23.5274 12.9828L24.2102 13.4392C24.2977 13.4967 24.4091 13.5015 24.5001 13.4512C24.5912 13.4009 24.6463 13.3038 24.6439 13.2008L24.6163 12.1024L24.7948 12.0892C24.8787 12.082 24.9553 12.0389 25.0033 11.9694L25.3099 11.5262C25.3411 11.4806 25.359 11.4243 25.359 11.368V10.5918L25.7627 9.90899C25.8011 9.8443 25.8119 9.76764 25.7927 9.69576C25.7735 9.62389 25.7256 9.5628 25.6609 9.52566L24.9458 9.11718C24.9038 9.09322 24.8559 9.08005 24.808 9.08005H24.5349C24.481 9.08005 24.4271 9.09682 24.3816 9.12677L23.7682 9.53644C23.755 9.54363 23.7431 9.55321 23.7323 9.56399L23.2507 10.0132L23.1441 10.0671L21.8049 9.35196C21.7773 9.33638 21.7462 9.3256 21.7138 9.32081L21.4227 9.28008L20.9567 7.38499C20.9244 7.25561 20.8058 7.16697 20.6728 7.17415L19.9924 7.2077C19.8642 7.21369 19.7576 7.30592 19.7337 7.43171L19.3635 6.87827L18.9802 5.47074C18.979 5.46954 18.979 5.46714 18.9778 5.46595L18.5693 4.06918C18.5477 3.99491 18.495 3.93262 18.4256 3.89788L16.7677 3.08571L15.3829 2.24118C15.3338 2.21243 15.2787 2.19806 15.2224 2.20045L15.2224 2.20041Z" fill="#1A124D"/>
                            </svg>
                         </div>

                         <div>
                            <span>Are either a New Zealand citizen living in New Zealand, or resident visa holder living in New Zealand</span>
                         </div>

                        <div>
                            <svg width="20" height="20" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.4993 0C23.7796 0 30.5 6.72043 30.5 15.0007C30.5 23.2796 23.7768 30 15.4993 30C7.22323 30 0.5 23.2768 0.5 15.0007C0.5 6.72043 7.21902 0 15.4993 0ZM16.8182 12.3876L21.4557 7.75016C19.8355 6.41757 17.762 5.61777 15.4995 5.61777C10.3158 5.61777 6.11942 9.81698 6.11942 15.0007H4.28694C4.28694 8.8118 9.31043 3.7855 15.4993 3.7855C18.9246 3.7855 21.9936 5.3235 24.0496 7.7463L22.7512 9.04463L22.7499 9.04326L18.1124 13.6807C18.3137 14.0779 18.4274 14.5258 18.4274 14.9996C18.4274 16.6116 17.1099 17.9264 15.4979 17.9264C13.8887 17.9264 12.5711 16.6102 12.5711 14.9996C12.5711 13.3876 13.8859 12.0701 15.4979 12.0701C15.9718 12.0701 16.421 12.1838 16.8168 12.3851L16.8182 12.3876ZM15.4993 13.9051C14.8885 13.9051 14.405 14.3913 14.405 15.0021C14.405 15.6075 14.8926 16.0964 15.4993 16.0964C16.1047 16.0964 16.5963 15.6088 16.5963 15.0021C16.5963 14.3913 16.1101 13.9051 15.4993 13.9051ZM15.4993 1.83371C8.22421 1.83371 2.33367 7.72705 2.33367 15.0021C2.33367 22.2772 8.22421 28.1678 15.4993 28.1678C22.7744 28.1678 28.6677 22.28 28.6677 15.0021C28.6677 7.72425 22.7786 1.83371 15.4993 1.83371Z" fill="#1A124D"/>
                            </svg>
                         </div>
                        
                         <div>
                            <span>Can meet our lending criteria and have a good credit history</span>
                         </div>

                        <div>
                            <svg class="svg-icon" width="20" height="20" fill="#1A124D" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <path d="M729.6 560c-80 0-147.2-64-147.2-147.2s64-147.2 147.2-147.2 147.2 64 147.2 147.2-67.2 147.2-147.2 147.2zM764.8 588.8h-12.8c-19.2 0-32 12.8-32 32 0 0 76.8 268.8 121.6 268.8h102.4c32 0 60.8-25.6 60.8-60.8 3.2-96-92.8-240-240-240z" />
                                <path d="M377.6 499.2C275.2 499.2 192 416 192 316.8s83.2-182.4 182.4-182.4 182.4 83.2 182.4 182.4-80 182.4-179.2 182.4zM665.6 889.6H86.4c-38.4 0-70.4-32-70.4-70.4 0-124.8 121.6-307.2 307.2-307.2h99.2c188.8 0 307.2 182.4 307.2 307.2 6.4 38.4-25.6 70.4-64 70.4z" />
                            </svg>
                        </div>

                        <div>
                            <span>Have no more than two borrowers/trustees</span>
                         </div>
                    </div>
                </div>

                <div>
                    <h2 class="calloutHeader text-center">What's the process?</h2>

                    <div class="residentialProcessGrid">
                        <section>
                            <div class="circle-graphic">1</div>
                            <h3>Application</h3>
                            <p>
                                The application will require you to include your personal and financial information and will take approximately 20-30 minutes to complete.
                            </p>
                        </section>
                        <div class="process-divider">
                        <!-- ---- -->
                        </div>
                        <section>
                            <div class="circle-graphic">2</div>
                            <h3>We'll be in touch</h3>
                            <p>
                                Once you've submitted your application, one of our Lending Specialists will be in touch within three business days to discuss your application with you.
                            </p>
                        </section>
                        <div class="process-divider">
                        <!-- ---- -->
                        </div>
                        <section>
                            <div class="circle-graphic">3</div>
                            <h3>Documentation</h3>
                            <p>
                                We may ask you to provide bank statements and payslips to support your application.
                            </p>
                        </section>
                    </div>
                    <p class="text-highlight" style="margin-top: 40px; text-align: left;">You can pause your application at any point by clicking the 'Save and Exit' button and we'll save your in-progress application so you can come back to it later. </p>
                </div>
            </div>
        `
    }

    window.cc_Analytics = {
        hashString: async (inputString) => {
            // Convert the input string to an array buffer
            const encoder = new TextEncoder();
            const dataBuffer = encoder.encode(inputString);

            try {
                // Use the SubtleCrypto API to hash the data with SHA-256
                const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);

                // Convert the hash buffer to a hexadecimal string
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                // Return the hashed value
                return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
            } catch (error) {
                // Throw an error if the hashing operation fails
                throw error;
            }
        },

        getEntered: (questionId) => {
            const question = cc_Model.anyLevelQuestionMap[questionId];
            return question && question.entered.length > 0 ? question.entered[0] : null;
        },

        getLoanType: () => {
            //home_loan for now as we only have 1 rulebook
            return "home_loan";
        },

        previousPageCompletedStatuses: {},

        setPageCompletedStatuses: () => {
            let result = {};

            $.each(cc_Model.topLevelPagesMap, function() {
                result[this.id] = !!this.completed;
            });
            cc_Analytics.previousPageCompletedStatuses = result;
        }
    }

    // LO-2951 removed event listeners for 'case-created', 'field-updated', 'page-error', 'page-start', 'page-complete' and 'detail-selection'
    document.addEventListener('cc-case-submit', async (event) => {
        const email = cc_Analytics.getEntered("Individual1Email");
        let hashedEmail = await cc_Analytics.hashString(email);

        const purchasePrice = cc_Analytics.getEntered("PropertySelected") == "Yes" ? cc_Analytics.getEntered("PropertyToPurchasePurchasePrice") : cc_Analytics.getEntered("RequestedAmount");
        const deposit = cc_Analytics.getEntered("PropertyToPurchaseDeposit");
        let borrowingAmount = purchasePrice - deposit;


        dataLayer.push({
            event: "form_submit",
            form_name: cip_Common.formId,
            is_existing_customer: cc_Analytics.getEntered("ContactInformationExistingClient"),
            borrowing_reason: cc_Analytics.getEntered("BorrowingPurpose"),
            borrowing_amount: borrowingAmount,
            user_data: {
                sha256_email: hashedEmail
            }
        });
    });

})();

function openNavigator() {
    $(".header").css("display", "none");
    $("#cloudcase-page-navigator").css("display", "flex");
    $("#cloudcase-page-navigator").css("min-width", "20rem");
    $("#cloudcase-page-navigator").css("width", "20rem");

};

function closeNavigator() {
    $(".header").css("display", "flex");
    $("#cloudcase-page-navigator").css("min-width", "0px");
    $("#cloudcase-page-navigator").css("width", "0px");
    $("#cloudcase-page-navigator").css("display", "none");
};